<template>
  <div>
    <mensajeSistema></mensajeSistema>
    <!-- boton crear -->
    <v-row class="" v-if="componenteEvento.agregar_submodulo">
      <v-col class="d-flex justify-end gap-10px">
        <TableButtonComp @click="addItem" normalButton textButton="Crear Efeméride" iconBut="fas fa-plus" />
        <TableButtonComp @click="dialogdelete = true" :disabled="!selected.length" normalButton textButton="Eliminar"
          iconBut="fas fa-trash-alt" classColor="red" />

        <ComunDialogComp v-model="dialogdelete
          " Deletedialog @close-modal="
            dialogdelete = false" @delete-item="deleteEfemerides" titleWindow="Eliminar efeméride"
          @cancel-item=" dialogdelete = false">
          <template v-slot:body>
            <div>
              <span v-if="selected.length > 1" class="text-h6">
                ¿Está seguro de eliminar estos registros?
              </span>
              <span v-else class="text-h6">
                ¿Está seguro de eliminar este registro?
              </span>
            </div>
          </template>
        </ComunDialogComp>
      </v-col>
    </v-row>

    <!-- consultar -->
    <ComundataTablecomp :headers="ConfigEfemeridesHeaders" :items="data" v-model="selected" whitSearch whitSelect
      noResultsText="Sin efemérides" placeholder-textsearch="Buscar efeméride">
      <!-- Si es VIDEO -->
      <template v-slot:filename="{ item }">
        <template v-if="checkExtension(item.nombre_original)">
          <video width="250" height="170" controls>
            <source :src="item.uri ? baseUrlS3 + item.uri : 'Video no encontrado'" type="video/mp4">
            Tu navegador no soporta videos.
          </video>
        </template>
        <!-- Si es IMAGEN -->
        <template v-else>
          <!-- <v-tooltip bottom> -->
          <!-- <template v-slot:activator="{ on, attrs }"> -->
          <!-- <v-chip dense v-bind="attrs" v-on="on">
              <v-icon left small>{{ item.filename ? "fas fa-image" : "fas fa-exclamation-circle" }}
              </v-icon>
              {{ item.filename ? item.filename : "Sin Imagen" }}
            </v-chip>
          </template> -->
          <img :src="item.uri ? baseUrlS3 + item.uri : ' Imagen no encontrada'"
            :alt="item.uri || ' Imagen no encontrada'" width="250" height="170" />
          <!-- </v-tooltip> -->
        </template>
      </template>

      <template v-slot:fecha_inicio="{ item }">
        <span>{{ formatFec(item.fecha_inicio) }}</span>
      </template>

      <template v-slot:fecha_fin="{ item }">
        <span>{{ formatFec(item.fecha_fin) }}</span>
      </template>

      <template v-slot:activo="{ item }">
        <v-chip :class="item.activo ? 'color_activo' : 'color_inactivo'" @click="editEstatus(item)" small>{{ item.activo
          ?
          "Activo" : "Inactivo" }}</v-chip>
      </template>

      <template v-slot:action_editar="{ item }">
        <TableButtonComp v-if="componenteEvento.editar_submodulo" @click="editItem(item)" editButton
          tooltip-text="Editar efeméride" />
      </template>
    </ComundataTablecomp>

    <!-- MODAL CREAR-->
    <v-form ref="formDatos" lazy-validation>
      <ComunDialogComp v-model="dialog
        " :evento="evento
          " @close-modal="closeModal
            " :title="evento ===
              'agregar'
              ? 'Crear efeméride'
              : 'Editar efeméride'
              " maxWidth="1200">
        <template v-slot:body>
          <v-row class="pa-0 ma-0">
            <v-col cols="12" sm="12" md="12" class="pb-0">
              <v-alert dense class="text-center" color="primary" dark>
                <h3>Datos de la efeméride</h3>
              </v-alert>
            </v-col>

            <v-col cols="12" md="12" sm="12" xs="12">
              <v-switch color="primary" v-model="efemeride.estado_efemeride"
                label="¿Desea que se muestre el titulo de la efemeride?"></v-switch>
            </v-col>

            <v-col cols="12" md="4" sm="6" xs="12" class="py-0">
              <textfieldComp textArea textLabel="Título"
                :rules="[...validationRules.validatetextArea, v => (v && v.trim().length <= 80 && v.trim().length != 0) || 'El título no puede exceder los 80 caracteres']"
                v-model="efemeride.titulo" />
            </v-col>

            <v-col cols="12" md="4" sm="6" xs="12" class="py-0">
              <textfieldComp textArea textLabel="Subtítulo" v-model="efemeride.subtitulo"
                :rules="[v => (v.trim().length <= 100) || 'El subtítulo no puede exceder los 100 caracteres']" />
              <div></div>
            </v-col>

            <v-col cols="12" md="4" sm="6" xs="12" class="pb-0">
              <v-file-input v-model="archivoSubir" accept=".jpg, .png, .gif" label="Imagen/Video"
                :rules="evento == 'agreagar' ? [rul.required] : []"></v-file-input>
            </v-col>

            <v-col cols="12" sm="12" md="12" class="pb-0">
              <v-alert dense class="text-center" color="primary" dark>
                <h3>Contenido de la efeméride</h3>
              </v-alert>
            </v-col>

            <v-col cols="12" class="">
              <ckeditor class="d-flex justify-center" tag-name="textarea" v-model="efemeride.contenido"
                :config="editorConfig"></ckeditor>
            </v-col>

            <v-col cols="12" xs="12" md="6" sm="6" class="py-0">
              <v-menu v-model="menuFechaIni" :close-on-content-click="false" transition="scale-transition" offset-y
                max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="computedDateFormatted3" label="Fecha de inicio" prepend-icon="mdi-calendar"
                    outlined dense readonly v-on="on" :rules="[rul.required]"></v-text-field>
                </template>

                <v-date-picker v-model="efemeride.fecha_inicio" no-title @input="menuFechaIni = false"></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" xs="12" md="6" sm="6" class="py-0">
              <v-menu v-model="menuFechaFin" :close-on-content-click="false" transition="scale-transition" offset-y
                max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="computedDateFormatted4" label="Fecha de finalización"
                    prepend-icon="mdi-calendar" outlined dense readonly v-on="on"
                    :rules="[rul.required]"></v-text-field>
                </template>

                <v-date-picker v-model="efemeride.fecha_fin" no-title @input="menuFechaFin = false"></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </template>
        <template v-slot:actions>
          <v-spacer></v-spacer>
          <TableButtonComp normalButton @click="saveModal()" :loading="isPending" iconBut="fas fa-save"
            :textButton="evento == 'agregar' ? 'Guardar' : 'Guardar cambios'" />

        </template>

      </ComunDialogComp>

    </v-form>
  </div>
</template>

<script>
import axios, { API_URL, BUCKET_ORIGIN_SPACE } from "@/helpers/axios";
import { mapMutations, mapGetters, mapActions } from "vuex";
import ComundataTablecomp from "../../../../components/ComponentsEst/ComundataTablecomp.vue";
import ComunDialogComp from "../../../../components/ComponentsEst/ComunDialogComp.vue";
import TableButtonComp from "../../../../components/ComponentsEst/TableButtonComp.vue";
import textfieldComp from "../../../../components/ComponentsEst/textfieldComp.vue";
import { ConfigEfemeridesHeaders } from "@/helpers/headersTable.js";
import { validationRules } from "@/helpers/validatorHelpers.js";
import moment from "moment";

export default {
  name: "configuracionEfemeride",
  components: {
    ComundataTablecomp,
    ComunDialogComp,
    TableButtonComp,
    textfieldComp
  },

  data: () => ({
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    rutaservidor: API_URL,
    rutaS3: BUCKET_ORIGIN_SPACE,
    ConfigEfemeridesHeaders,
    isloading: false,
    paramComponente: { id_submodulo: 143, id_modulo: 3 }, //sud_modulo y modulo
    datoLogin: sessionStorage, // variables de sesion del usuario
    ////////////////////////////////////////////////////////

    rul: {
      required: (value) => !!value || "Campo requerido",
      inputReq: (value) => !!value || "Campo requerido",
      selectReq: (value) => !!value || "Debe seleccionar un campo de la lista",
      email: (value) =>
        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) ||
        "El correo Electrónico es incorrecto",
      min4: (v) => (v || "").length >= 4 || "Mínimo 4 caracteres",
      min6: (v) => (v || "").length >= 6 || "Mínimo 6 caracteres",
      min8: (v) => (v || "").length >= 8 || "Mínimo 8 caracteres",
      max10: (v) => (v || "").length <= 10 || "Máximo 10 caracteres",
      max11: (v) => (v || "").length <= 11 || "Máximo 11 caracteres",
      max12: (v) => (v || "").length <= 12 || "Máximo 12 caracteres",
      max20: (v) => (v || "").length <= 20 || "Máximo 20 caracteres",
      max30: (v) => (v || "").length <= 30 || "Máximo 30 caracteres",
      max40: (v) => (v || "").length <= 40 || "Máximo 40 caracteres",
      max50: (v) => (v || "").length <= 50 || "Máximo 50 caracteres",
      max60: (v) => (v || "").length <= 60 || "Máximo 60 caracteres",
      max100: (v) => (v || "").length <= 100 || "Máximo 100 caracteres",
      max150: (v) => (v || "").length <= 150 || "Máximo 150 caracteres",
      tipo: (v) =>
        (v || "").length <= 15 ||
        "Número de Documento debe ser máximo 15 Dígitos",

      email_null: (value) => {
        if (value == "") {
          return false;
        } else {
          const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/;
          return pattern.test(value) || "El correo Electrónico es incorrecto";
        }
      },
      hora: (value) => {
        if (value < "01:00") {
          return "El formato de la hora ingresada es incorrecto";
        } else {
          if (value >= "13:00") {
            return "El formato de la hora ingresada es incorrecto";
          }
          return true;
        }
      },
    },

    selected: [],
    data: [],
    isPending: false,

    efemeride: {
      id_colegio: sessionStorage.id_colegio,
      id_ano_lectivo: sessionStorage.id_ano_lectivo,
      titulo: "",
      subtitulo: "",
      contenido: "",
      fecha_inicio: null,
      fecha_fin: null,
      estado_efemeride: false,
    },
    dialog: false,
    evento: "agregar",
    dialogdelete: false,
    menuFechaIni: false,
    menuFechaFin: false,
    archivoSubir: null,

    //CONTENIDO EDITOR CONFIG
    editorConfig: {
      extraPlugins: "language,font,image",
      toolbar: [
        "Format",
        ["Bold", "Italic", "Strike", "Underline"],
        ["BulletedList", "NumberedList", "Blockquote"],
        ["JustifyLeft", "JustifyCenter", "JustifyRight", "JustifyBlock"],
        ["Link", "Unlink"],
        ["FontSize", "TextColor"],
        ["Image"],
        ["Undo", "Redo"],
        ["Source", "Maximize"],
      ],
      height: "200",
      width: "95%",
      toolbarCanCollapse: true,
      allowedContent: true,
      // uiColor: "#01579b",
      codeSnippet_theme: "pojoaque",
      filebrowserImageBrowseLinkUrl:
        "https://onedrive.live.com/?id=59FFBD6D7046F78D%21105&cid=59FFBD6D7046F78D",
      font_names:
        "Arial/Arial, Helvetica, sans-serif;" +
        "Times New Roman/Times New Roman, Times, serif;" +
        "Verdana",

      codeSnippet_languages: {
        javascript: "JavaScript",
        php: "PHP",
      },
    },
  }),

  //computadas
  computed: {
    ...mapGetters("login", ["componenteEvento"]),

    validationRules() {
      return validationRules;
    },

    computedDateFormatted3() {
      return this.efemeride.fecha_inicio
        ? moment(this.efemeride.fecha_inicio).format("DD/MM/YYYY")
        : "";
    },

    computedDateFormatted4() {
      return this.efemeride.fecha_fin
        ? moment(this.efemeride.fecha_fin).format("DD/MM/YYYY")
        : "";
    },
    baseUrlS3() {
      return this.rutaS3 + "/"
    },
  },

  mounted() {
    this.loadMain();
    this.addClaseSecondary();
  },

  updated() {
    this.addClaseSecondary();
  },

  created() {
    this.actualizarParamentro();
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA //////////////////////
    // -- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),
    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ////////////////////////////////////////////////////////

    //  ------- input tipo fecha  --------
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    //-- cargar Parametros de inicio del componente --
    async loadMain() {
      this.limpiarForm();
      this.getEfemerides();
    },

    limpiarForm() {
      (this.efemeride = {
        id_colegio: sessionStorage.id_colegio,
        id_ano_lectivo: sessionStorage.id_ano_lectivo,
        titulo: "",
        subtitulo: "",
        contenido: "",
        fecha_inicio: "",
        fecha_fin: "",
        estado_efemeride: false,
      }),
        (this.archivoSubir = null);
      this.resetValidation();
    },

    checkExtension(nombre) {
      if (!nombre) return false; // Retorna false si filename no está definido
      // expresión regular que busca las extensiones al final del nombre del archivo
      const regex = /\.(mp4|mov|avi|mkv)$/;
      // Retorna true si encuentra alguna de las extensiones, false en caso contrario
      return regex.test(nombre);
    },

    resetValidation() {
      this.$refs.formDatos.resetValidation();
    },

    addItem() {
      this.evento = "agregar";
      this.limpiarForm();
      this.dialog = true;
    },

    closeModal() {
      this.limpiarForm();
      this.dialog = false;
    },

    async editEstatus(item) {
      try {
        const estatus = !item.activo;
        let res = await axios.put(`/inicio/efemerides/${item.id}/`, {
          activo: estatus,
        });

        if (res.data.messageT == "S") {
          item.activo = estatus;
        }
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    editItem(item) {
      this.evento = "editar";
      this.efemeride = item;
      this.dialog = true;
    },

    async saveModal() {
      this.isloading = true
      if (this.$refs.formDatos.validate()) {
        try {
          this.isPending = true;
          if (
            moment(this.efemeride.fecha_inicio) >
            moment(this.efemeride.fecha_fin)
          ) {
            this.setEnviarMens({
              tipo: "W",
              mensaje: `La fecha fin debe ser mayor a la fecha inicial`,
              tiempo: null,
            });
            return;
          }
          let formData = new FormData();
          formData.append("id_usuario", sessionStorage.id);
          if (this.archivoSubir) formData.append("subirArchivo", this.archivoSubir);
          const keys = Object.keys(this.efemeride);
          for (let index = 0; index < keys.length; index++) {
            const key = keys[index];
            if (key != "id") formData.append(key, this.efemeride[key]);
          }

          let res = null;
          if (this.evento == "agregar") {
            this.isloading = true
            res = await axios.post("/inicio/efemerides/", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            });
          } else {
            res = await axios.put(
              `/inicio/efemerides/${this.efemeride.id}/`,
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            );
          }

          if (res.data.messageT == "S") {
            this.setEnviarMens({
              tipo: "S",
              mensaje: res.data.message,
              tiempo: null,
            });
            this.limpiarForm();
            this.savenotif();
            this.isloading = false
            console.log('loading en false');

            this.dialog = false;
            this.loadMain();
          }
        } catch (error) {
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        } finally {
          this.isPending = false;
        }

      }
    },

    async savenotif() {
      let titulo = ''
      let contenido = ''
      let action = ''
      if (this.evento == 'agregar') {
        titulo = 'Anuncio'
        contenido = 'Se agrego una efeméride para todos los usuarios del colegio ' + this.datoLogin.nombre_colegio
        action = 'fas fa-plus-square'
      } else {
        titulo = 'Anuncio'
        contenido = 'Se edito una efeméride para todos los usuarios del colegio ' + this.datoLogin.nombre_colegio
        action = 'fas fa-edit'
      }
      const fechaActual = new Date();
      const horaActual = fechaActual.toLocaleTimeString('en-GB', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      });

      const datanotif = {
        id_colegio: this.datoLogin.id_colegio,
        id_ano_lectivo: this.datoLogin.id_ano_lectivo,
        titulo_notif: titulo,
        contenido_notif: contenido,
        id_perfil: this.datoLogin.id_perfil,
        id_usuario: this.datoLogin.id,
        fecha_notif: fechaActual,
        hora_notif: horaActual,
        icon_notif: action,
      };
      try {
        const response1 = await axios.post("/notification/persona/addglobalnotif/", datanotif);
        this.setEnviarMens({ tipo: `${response1.data.messageT}`, mensaje: `${response1.data.message}`, tiempo: null });
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async getEfemerides() {
      try {
        let response = await axios.get(
          `/inicio/efemerides/${sessionStorage.id_colegio}`
        );
        this.data = response.data;

      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async deleteEfemerides() {
      try {
        if (!this.selected.length) {
          //Si no hay ninguno seleccionado
          this.setEnviarMens({
            tipo: "E",
            mensaje: "Seleccione al menos un elemento para eliminar",
            tiempo: null,
          });
          return
        }


        let response = await axios.post(`/inicio/efemerides/deleteMasive/`, {
          efemerides: this.selected.map((c) => c.id),
        });

        if (response.data.messageT == "S") {
          this.setEnviarMens({
            tipo: "S",
            mensaje: response.data.message,
            tiempo: null,
          });
          this.selected.splice(0); //Vaciar selected	
          this.getEfemerides();
          this.dialogdelete = false;
        }
        else if (response.data.messageT === "E") {
          this.setEnviarMens({
            tipo: "E",
            mensaje: response.data.message,
            tiempo: null,
          });
        }
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    formatFec(fecha) {
      return moment(fecha).format("DD/MM/YYYY");
    },

    addClaseSecondary() {
      let ths = document.querySelectorAll("th[role='columnheader']");
      ths.forEach((th) => th.classList.add("secondary"));
    },
  },
};
</script>